import { render, staticRenderFns } from "./PlansContent.vue?vue&type=template&id=38f58dc7&scoped=true"
import script from "./PlansContent.vue?vue&type=script&lang=js"
export * from "./PlansContent.vue?vue&type=script&lang=js"
import style0 from "./PlansContent.vue?vue&type=style&index=0&id=38f58dc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f58dc7",
  null
  
)

export default component.exports